import React from "react";

export default function SimpleDivider() {
  return (
    <div className="px-4 w-full mx-auto">
      <div className="max-w-7xl border-t mx-auto border-gray-300" />
    </div>
  );
}

export function DividerWithText({ text }) {
  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-300" />
      </div>
      <div className="relative flex justify-center">
        <span className="px-2 bg-gray-50 text-sm text-gray-500">{text}</span>
      </div>
    </div>
  );
}

